import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Notes } from './notes.component';
import { selectBookingNotes, BookingActions } from '../../../../modules/booking';

const mapStateToProps = createStructuredSelector({
  notes: selectBookingNotes,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onNotesChanged: BookingActions.setNotes,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(Notes);
